export default __webpack_public_path__ + "static/media/Identify Weakpoint.e6d9eced.png";